import { CCol, CRow } from "@coreui/react";
import React, { useEffect, useState } from "react";
import CommonList from "../crud/CommonList";
import { apiCall, apiCallResponse } from "src/_apiConfig/apiCall";
import Auth from "src/auth";
import { CommonSearch, updateSearchStatus } from "../common/CommonSearch";
import {
  FilterEqual,
  FilterContainsInsensitive,
  FilterContainsTwoField,
} from "../common/FilterCondition";

const ABSBankGuaranteePaymentList = () => {
  const [bankguaranteelist, setbankguaranteelist] = useState();
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const [loading, setloading] = useState(false); // page loading
  const [pageLimit, setpageLimit] = useState(0); // pageing index manage
  const [itemPerPage, setItemPerPage] = useState(10); // Record Show Each Page
  const [disabledprev, setdisabledprev] = useState(false); //Pagging Prev. Button disabled manage
  const [disablednext, setdisablednext] = useState(false); //Pagging Next Button disabled manage
  const { authenticated } = Auth();
  // eslint-disable-next-line no-unused-vars
  const [disabledApproveRej, setdisabledApproveRej] = useState(false);

  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage

  const SearchFilterModule = {
    collectionSeason: new Date().getFullYear().toString(),
    tenderNo: "",
    lotNo: "",
    companyName: "",
  };

  // Search Model
  const [search, setSearch] = useState(SearchFilterModule);

  useEffect(() => {
    setloading(true);
    reset();
    getPageCount(true);
    if (authenticated.role === "DFO" && authenticated.isViewOnly) {
      setdisabledApproveRej(true);
    } else {
      setdisabledApproveRej(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getBGList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit]);

  useEffect(() => {
    if (isSearch) {
      getPageCount();
      getBGList(true);
      setIsClear(false);
      setIsSearch(false);
      // reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  const approveBG = async (lotpaymentid, isTransferLotBG, ABSBGPaymentId) => {
    console.log(ABSBGPaymentId);
    const header = new Headers();
    header.append("Content-Type", "application/json");
    const response = await apiCall(
      "BG/ApporveRejectABSBG",
      "POST",
      header,
      JSON.stringify({
        isApprove: true,
        lotPaymentId: lotpaymentid,
        userId: authenticated.userId,
        paymentid: ABSBGPaymentId,
      })
    );

    await response.json();
    if (response.status === 200) {
      alert("BG Approved Successfully.");
      getBGList();
    }
  };

  const rejectBG = async (lotpaymentid, isTransferLotBG, ABSBGPaymentId) => {
    const header = new Headers();
    header.append("Content-Type", "application/json");
    const response = await apiCall(
      "BG/ApporveRejectABSBG",
      "POST",
      header,
      JSON.stringify({
        isApprove: false,
        lotPaymentId: lotpaymentid,
        userId: authenticated.userId,
        paymentid: ABSBGPaymentId,
      })
    );

    await response.json();
    if (response.status === 200) {
      alert("BG Reject Successfully.");
      getBGList();
    }
  };

  const reset = () => {
    setpageLimit(0);
  };

  const filterManage = () => {
    let filter = "";
    filter = "&$filter=";
    filter = FilterContainsInsensitive(filter, "lotNo", search.lotNo);

    filter = FilterContainsTwoField(
      filter,
      "transferFrom",
      "transferTo",
      search.companyName
    );
    // if (search.companyName !== "" && search.companyName !== undefined) {
    //   if (filter !== "&$filter=") {
    //     filter += " and ";
    //   }
    //   filter += "(contains(transferFrom,'" + search.companyName + "')";
    //   filter += "or contains(transferTo,'" + search.companyName + "'))";
    // }
    filter = FilterEqual(filter, "collectionSeason", search.collectionSeason);
    filter = FilterEqual(filter, "tenderNo", search.tenderNo);

    if (filter === "&$filter=") {
      filter = "";
    }
    return filter;
  };
  const getBGList = async (firstRequest) => {
    if (authenticated) {
      paggingDisabled();
      setloading(true);

      await apiCallResponse(
        `BG/ABSBankGuaranteePaymentList?userid=${
          authenticated.userId
        }&districtid=${
          authenticated.district
        }&$skip=${pageLimit}&$top=${parseInt(itemPerPage)}${filterManage()}`
      )
        .then((res) => {
          if (res.success) {
            setbankguaranteelist(res.data);
            if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
              paggingManage(pageCount);
            }
          } else {
            setbankguaranteelist();
            paggingManage(0, false);
          }
        })
        .finally(() => {
          setloading(false);
        });
    }
  };
  const getPageCount = async () => {
    if (authenticated) {
      await apiCallResponse(
        `BG/ABSBankGuaranteePaymentList?userid=${
          authenticated.userId
        }&districtid=${authenticated.district}${filterManage()}`
      ).then((res) => {
        if (res.success) paggingManage(parseInt(res.data.length) || 0);
        else paggingManage(0, false);
      });
    }
  };

  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  const paggingManage = (totalRecord, isRecordGet = true) => {
    if (isRecordGet === false) {
      setPageCount(0);
      paggingDisabled();
    } else {
      setPageCount(parseInt(totalRecord));
      paggingDisabled(
        pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
        pageLimit === 0
      );
    }
  };
  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitCheck = pageLimit - parseInt(itemPerPage);
    if (pageLimitCheck < 0) {
      pageLimitCheck = 0;
    }
    setpageLimit(pageLimitCheck);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitCheck = pageLimit + parseInt(itemPerPage);
    if (pageLimitCheck >= parseInt(pageCount)) {
      pageLimitCheck = parseInt(pageCount);
      setdisablednext(true);
    }
    setpageLimit(pageLimitCheck);
  };
  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    updateSearchStatus(setSearch, search, e, name, value);
  };
  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    setpageLimit(0);
    setItemPerPage(ev.target.value);
    setIsSearch(true);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    reset();
    setIsSearch(true);
  };
  const clearSearch = (ev) => {
    ev.preventDefault();
    reset();
    setIsClear(true);
    setIsSearch(true);
    setSearch({ ...search, ...SearchFilterModule });
    setbankguaranteelist();
  };
  let fields = [
    // {
    //   key: "tenderId",
    //   _style: { width: "6%" },
    //   label: <div>Tender Id</div>,
    // },
    {
      key: "tenderNo",
      _style: { width: "6%" },
      label: <div>Tender No</div>,
    },
    {
      key: "companyName",
      _style: { width: "15%" },
      label: <div>Company Name</div>,
    },
    {
      key: "bidderName",
      _style: { width: "15%" },
      label: <div>Bidder Name</div>,
    },
    {
      key: "emailAddress",
      _style: { width: "15%" },
      label: <div>Email Address</div>,
    },
    {
      key: "lotNo",
      _style: { width: "6%" },
      label: <div>Lot No</div>,
    },
    {
      key: "amount",
      _style: { width: "8%" },
      label: <div>Amount</div>,
    },
    {
      key: "BGDueDate",
      _style: { width: "8%" },
      label: <div>Last Date</div>,
    },
    {
      key: "viewBG",
      label: "View",
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },
    {
      key: "approveBG",
      label: "Approve",
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },
    {
      key: "rejectBG",
      label: "Reject",
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },
  ];

  const additional = (
    <CommonSearch
      isDisabledSearchClear={loading}
      isClear={isClear}
      search={search}
      updateSearch={updateSearch}
      searchButton={searchButton}
      clearSearch={clearSearch}
      itemPerPage={itemPerPage}
      onChangePage={onChangePage}
      isCompanyNameDisplay={true}
      //isEmailAddressDisplay={true}
      isLotNumberDisplay={true}
    />
  );
  return (
    <>
      <CRow>
        <CCol xl={12}>
          <CommonList
            items={bankguaranteelist}
            fields={fields}
            listName="Access Benefit Sharing BG List"
            loading={loading}
            additional={additional}
            prev={prevButton}
            next={nextButton}
            disabledprev={disabledprev}
            disablednext={disablednext}
            approveBG={approveBG}
            rejectBG={rejectBG}
            disableApproveReject={disabledApproveRej}
          />
        </CCol>
      </CRow>
    </>
  );
};
export default ABSBankGuaranteePaymentList;
